import { render, staticRenderFns } from "./NoteDetailsContentsList.vue?vue&type=template&id=304ea61c&scoped=true&"
import script from "./NoteDetailsContentsList.vue?vue&type=script&lang=js&"
export * from "./NoteDetailsContentsList.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetailsContentsList.vue?vue&type=style&index=0&id=304ea61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304ea61c",
  null
  
)

export default component.exports